module.exports = __webpack_public_path__ + "img/sartan_yes.821b14d1.png";